module.exports = __webpack_public_path__ + "img/sticker-0-5.7f70b589.svg";